import { axios } from "../../../constants/axiosConfig";

export async function getBloqueioCfopConfiguracao(cnpj) {
  try {
    const { data } =  await axios.post(`envioArquivos/v2/bloquear?cnpj=${cnpj}`);

    return data;
  } catch (err) {
    return null;
  }
}